// The author select, and what it offers. Pure, like the page editor's
// sections.js, so the option list a form shows is one function a test can
// call — and so the post editor and any later picker agree on the wording of
// "no author".
export const authorOptions = (authors) => () => [
  { value: "", label: "No author" },
  ...(authors || []).map(({ authorId, name }) => ({
    value: authorId,
    label: name ? `${name} (${authorId})` : authorId,
  })),
];

export const findAuthor = (authors, authorId) =>
  authorId ? (authors || []).find((author) => author.authorId === authorId) : undefined;
